import { useState, useEffect } from 'react';
import { Loader, ModalGeneric, Table } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

import { getTypesOfImputationForServiceRequest } from '../../../../services/serviceRequest';
import useToast from '../../../../hooks/useToast';

import './ModalDetailsIO.scss';

const ModalDetailsIO = ({ setShowDetailIOModal, showDetailIOModal, infoRowSelected }) => {
  const [typeOI, setTypeOI] = useState(null);
  const [loading, setLoading] = useState(false);
  const { setNewToast } = useToast();

  const getimputationObject = async (id, solicitudMensualizada) => {
    try {
      setLoading(true);
      const resp = await getTypesOfImputationForServiceRequest(id, solicitudMensualizada);

      const { tiposImputacion } = resp;

      setTypeOI(tiposImputacion);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error?.message || 'No pudimos procesar la solicitud, intente nuevamente.'
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (showDetailIOModal === true)
      getimputationObject(infoRowSelected?.id, infoRowSelected?.solicitudMensualizada);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDetailIOModal]);

  const columns = [
    {
      Header: 'Tipo OI',
      accessor: 'tipoObjetoImputacion',
      hideSort: true
    },
    {
      Header: 'Ubicación',
      accessor: 'ubicacion',
      hideSort: true
    },
    {
      Header: '	Obj. Imputación',
      accessor: 'objetoImputacion',
      hideSort: true
    }
  ];

  return (
    <>
      {loading ? (
        <Loader show={loading} text="CARGANDO..." />
      ) : (
        <ModalGeneric
          backdrop="static"
          infoModal
          onHide={() => setShowDetailIOModal(false)}
          primaryAction={() => {
            setTypeOI(null);
            setShowDetailIOModal(false);
          }}
          primaryActionLabel="Salir"
          show={showDetailIOModal}
          size="lg"
          title={infoRowSelected?.numero}
          variantHeader="light"
        >
          <div className="modal-styles content-Scroll-Data ">
            {typeOI && (
              <Table columns={columns} data={typeOI} key={typeOI.id} titleLeft type="light" />
            )}
          </div>
        </ModalGeneric>
      )}
    </>
  );
};

export default ModalDetailsIO;

ModalDetailsIO.propTypes = {
  setShowDetailIOModal: PropTypes.func,
  showDetailIOModal: PropTypes.bool,
  infoRowSelected: PropTypes.shape({
    id: PropTypes.number,
    numero: PropTypes.string,
    solicitudMensualizada: PropTypes.bool
  }).isRequired
};

ModalDetailsIO.defaultProps = {
  setShowDetailIOModal: () => {},
  showDetailIOModal: false
};
